import {
    LOAD_ACCESS_TOKEN,
    REFRESH_TOKEN_SUCCESS,
    REMOVE_OLD_TOKEN,
    TOKEN_REFRESH_FAILURE,
    UNAUTHORIZED_TOKEN_REFRESH,
    USER_LOGIN_SUCCESS,
    USER_LOGOUT,
} from '../actions/authentication';

let refreshAttempts = 0;
let refreshTokenTimer = null;

export const getRefreshTimeoutInSec = (secondsToLogout) => {
    let result = 0;
    if (secondsToLogout > 60) {
        result = secondsToLogout - 60;
    } else if (secondsToLogout > 40) {
        result = secondsToLogout - 40;
    } else if (secondsToLogout > 10) {
        result = secondsToLogout - 10;
    }
    return result;
};

export const shouldProcessNewAccessToken = (actionType) => actionType === LOAD_ACCESS_TOKEN || actionType === USER_LOGIN_SUCCESS || actionType === REFRESH_TOKEN_SUCCESS;

export const shouldHandleTokenRefreshFailure = (actionType) => actionType === TOKEN_REFRESH_FAILURE;

export const shouldDoCleanup = (actionType) => actionType === USER_LOGOUT || actionType === UNAUTHORIZED_TOKEN_REFRESH || actionType === REMOVE_OLD_TOKEN;

export const incrementRefreshAttempts = () => refreshAttempts++;

export const shouldRefresh = () => refreshAttempts < 3;

export const clearRefreshAttempts = () => {
    refreshAttempts = 0;
};

export const clearRefreshTokenTimer = () => clearTimeout(refreshTokenTimer);

export const initRefreshTokenTimer = (handler, milisecsToRefreshToken) => {
    refreshTokenTimer = setTimeout(handler, milisecsToRefreshToken);
};
